(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[793],{

/***/ 1887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(92310);

/***/ }),

/***/ 88211:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcast/tag/[tag]",
      function () {
        return __webpack_require__(46020);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81990);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40592);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 48px;\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 32px;\n  }\n\n  @media ",
        " {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var GridWrapper = function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Wrapper, {
        className: className,
        children: children
    });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d588b636-0"
})(_templateObject(), _theme_device__WEBPACK_IMPORTED_MODULE_2__/* .device.L */ .U.L, _theme_device__WEBPACK_IMPORTED_MODULE_2__/* .device.M */ .U.M);
/* harmony default export */ __webpack_exports__["Z"] = (GridWrapper);


/***/ }),

/***/ 26221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1887);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39321);




var Head = function(param) {
    var title = param.title, description = param.description, url = param.url, imageUrl = param.imageUrl, imageAlt = param.imageAlt, noIndex = param.noIndex;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:site_name",
                content: "Street of Code"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "twitter:site",
                content: "@StreetofCode1"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:locale",
                content: "sk_SK"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:image",
                content: imageUrl || _constants__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_LOGO_IMAGE_URL */ .PX
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:image:alt",
                content: imageAlt || title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "google-site-verification",
                content: "FB24EUCOSSYhz39LdPTSNW4Yebc0El71AV7luRQcQQc"
            }),
            noIndex && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "robots",
                content: "noindex"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Head);


/***/ }),

/***/ 41246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25925);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81990);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40592);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  align-self: center;\n  padding: 50px 32px 100px 32px;\n  width: clamp(320px, 100%, 1200px);\n\n  @media ",
        " {\n    max-width: 900px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PageContentWrapper = function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: className
    }, props), {
        children: children
    }));
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db8ecefa-0"
})(_templateObject(), _theme_device__WEBPACK_IMPORTED_MODULE_2__/* .device.L */ .U.L);
/* harmony default export */ __webpack_exports__["Z"] = (PageContentWrapper);


/***/ }),

/***/ 34908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81990);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60071);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _core_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96169);
/* harmony import */ var _core_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43195);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);
/* harmony import */ var _core_Flex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90656);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40592);
/* harmony import */ var _blog_clanky_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59982);
/* harmony import */ var _podcast_podcast_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86953);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 3.2em;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 360px;\n  height: 500px;\n  padding: 16px 24px;\n  border-right: var(--color-accent) 4px solid;\n  border-left: var(--color-accent) 4px solid;\n  box-shadow: 0px 2px 2px var(--color-shadow), 0px -2px 2px var(--color-shadow);\n  border-radius: 16px;\n  transition: 250ms ease-in-out;\n\n  &:hover {\n    transform: scale(1.05);\n    transition: 250ms ease-in-out;\n    box-shadow: 0px 4px 10px var(--color-shadow),\n      0px -4px 10px var(--color-shadow);\n  }\n\n  @media ",
        " {\n    width: 345px;\n    height: 480px;\n  }\n\n  @media ",
        " {\n    width: 320px;\n    height: 440px;\n  }\n\n  @media ",
        " {\n    width: 300px;\n    height: 400px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  line-height: 1.4;\n  height: 5.2em;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  opacity: 0.85;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  // images will adapt to this size while preserving their aspect-ratio\n  width: 220px;\n  height: 220px;\n\n  [theme-type='DARK'] & {\n    filter: brightness(0.9);\n  }\n\n  img {\n    object-position: left;\n  }\n\n  @media ",
        " {\n    width: 180px;\n    height: 180px;\n  }\n\n  @media ",
        " {\n    width: 160px;\n    height: 160px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}











/***
 * Works with blog posts and podcasts.
 * Featured image should work with any aspect-ratio.
 */ var PostPreviewCard = function(param) {
    var post = param.post, isPodcast = param.isPodcast;
    var ref, ref1, ref2;
    var featuredImage = (ref = post.featuredImage) === null || ref === void 0 ? void 0 : ref.node;
    var authorName = post.author ? ((ref1 = post.author.node) === null || ref1 === void 0 ? void 0 : ref1.firstName) && post.author.node.lastName ? "".concat(post.author.node.firstName, " ").concat(post.author.node.lastName) : (ref2 = post.author.node) === null || ref2 === void 0 ? void 0 : ref2.name : null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(WrapperFlex, {
        direction: "column",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                direction: "column",
                gap: "18px",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        direction: "column",
                        gap: "8px",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FixedSizedHeading, {
                                variant: "h6",
                                align: "center",
                                children: post.title
                            }),
                            post.excerpt && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Excerpt, {
                                align: "center",
                                dangerouslySetInnerHTML: {
                                    __html: post.excerpt
                                }
                            })
                        ]
                    }),
                    featuredImage && featuredImage.sourceUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(ImageWrapper, {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            layout: "fill",
                            src: featuredImage.sourceUrl,
                            alt: post.title || "",
                            objectFit: "contain",
                            priority: true
                        })
                    }),
                    !featuredImage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(ImageWrapper, {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            layout: "fill",
                            src: isPodcast ? _podcast_podcast_constants__WEBPACK_IMPORTED_MODULE_9__/* .EMPTY_PODCAST_IMAGE_PLACEHOLDER_URL */ .SA : _blog_clanky_constants__WEBPACK_IMPORTED_MODULE_10__/* .EMPTY_BLOG_IMAGE_PLACEHOLDER_URL */ .xf,
                            alt: post.title || "",
                            objectFit: "contain",
                            priority: true
                        })
                    })
                ]
            }),
            isPodcast && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(PaddedFlex, {
                justifyContent: "space-between",
                alignSelf: "stretch",
                alignItems: "flex-end",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: _podcast_podcast_constants__WEBPACK_IMPORTED_MODULE_9__/* .PODCAST_MICROPHONE_IMG */ .zI,
                        width: 20,
                        height: 40
                    }),
                    post.date && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_core_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        size: "small",
                        children: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(new Date(post.date))
                    })
                ]
            }),
            !isPodcast && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(PaddedFlex, {
                justifyContent: "space-between",
                alignSelf: "stretch",
                children: [
                    post.date && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_core_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        size: "small",
                        children: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(new Date(post.date))
                    }),
                    authorName && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_core_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        align: "right",
                        children: authorName
                    })
                ]
            })
        ]
    });
};
var FixedSizedHeading = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_core_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8d7bb97a-0"
})(_templateObject());
var WrapperFlex = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8d7bb97a-1"
})(_templateObject1(), _theme_device__WEBPACK_IMPORTED_MODULE_7__/* .device.L */ .U.L, _theme_device__WEBPACK_IMPORTED_MODULE_7__/* .device.S */ .U.S, _theme_device__WEBPACK_IMPORTED_MODULE_7__/* .device.XS */ .U.XS);
var PaddedFlex = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8d7bb97a-2"
})(_templateObject2());
var Excerpt = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_core_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8d7bb97a-3"
})(_templateObject3());
var ImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8d7bb97a-4"
})(_templateObject4(), _theme_device__WEBPACK_IMPORTED_MODULE_7__/* .device.S */ .U.S, _theme_device__WEBPACK_IMPORTED_MODULE_7__/* .device.XS */ .U.XS);
/* harmony default export */ __webpack_exports__["Z"] = (PostPreviewCard);


/***/ }),

/***/ 52463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80371);
/* harmony import */ var _core_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90656);
/* harmony import */ var _core_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96169);
/* harmony import */ var _core_NextLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96791);
/* harmony import */ var _GridWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77497);
/* harmony import */ var _PostPreviewCard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34908);








var PostTags = function(param) {
    var tag = param.tag, posts = param.posts, podcastTags = param.podcastTags;
    if (posts.length === 0) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .Fragment */ .HY, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_core_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                direction: "column",
                justifyContent: "center",
                gap: "48px",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_core_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        variant: "h3",
                        align: "center",
                        children: "Nenašli sa žiadne čl\xe1nky"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_core_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        href: podcastTags ? _routes__WEBPACK_IMPORTED_MODULE_1__/* .routes.podcast.index */ ._.podcast.index : _routes__WEBPACK_IMPORTED_MODULE_1__/* .routes.clanky.index */ ._.clanky.index,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_core_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            variant: "h4",
                            withAccentUnderline: true,
                            children: [
                                "Zobraziť vsetky ",
                                podcastTags ? "podcasty" : "čl\xe1nky"
                            ]
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_core_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        direction: "column",
        gap: "36px",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_core_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        inline: true,
                        align: "center",
                        variant: "h2",
                        children: tag.raw
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_core_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        inline: true,
                        variant: "h2",
                        color: "accent",
                        children: [
                            " ",
                            podcastTags ? "podcasty" : "čl\xe1nky"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_GridWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: posts.map(function(post, i) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_core_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        href: podcastTags ? _routes__WEBPACK_IMPORTED_MODULE_1__/* .routes.podcast.slug */ ._.podcast.slug(post.slug || "") : _routes__WEBPACK_IMPORTED_MODULE_1__/* .routes.clanky.slug */ ._.clanky.slug(post.slug || ""),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_PostPreviewCard__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            post: post
                        })
                    }, i);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostTags);


/***/ }),

/***/ 59982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NH": function() { return /* binding */ TOP_TAGS_COUNT; },
/* harmony export */   "_9": function() { return /* binding */ CATEGORY_NAME; },
/* harmony export */   "ef": function() { return /* binding */ RECOMMENDED_POSTS_COUNT; },
/* harmony export */   "xf": function() { return /* binding */ EMPTY_BLOG_IMAGE_PLACEHOLDER_URL; }
/* harmony export */ });
var CATEGORY_NAME = "Blog";
var EMPTY_BLOG_IMAGE_PLACEHOLDER_URL = "http://wp.streetofcode.sk/wp-content/uploads/2022/09/Group-141.png";
var RECOMMENDED_POSTS_COUNT = 3;
var TOP_TAGS_COUNT = 8;


/***/ }),

/***/ 86953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$o": function() { return /* binding */ RECOMMENDED_PODCASTS_COUNT; },
/* harmony export */   "NH": function() { return /* binding */ TOP_TAGS_COUNT; },
/* harmony export */   "R": function() { return /* binding */ COUNT_IN_SLIDER; },
/* harmony export */   "SA": function() { return /* binding */ EMPTY_PODCAST_IMAGE_PLACEHOLDER_URL; },
/* harmony export */   "_9": function() { return /* binding */ CATEGORY_NAME; },
/* harmony export */   "zI": function() { return /* binding */ PODCAST_MICROPHONE_IMG; }
/* harmony export */ });
var COUNT_IN_SLIDER = 6;
var CATEGORY_NAME = "Podcast";
var EMPTY_PODCAST_IMAGE_PLACEHOLDER_URL = "http://wp.streetofcode.sk/wp-content/uploads/2020/12/PodcastImage.jpg";
var PODCAST_MICROPHONE_IMG = "http://wp.streetofcode.sk/wp-content/uploads/2022/09/Group-145.png";
var RECOMMENDED_PODCASTS_COUNT = 3;
var TOP_TAGS_COUNT = 10;


/***/ }),

/***/ 46020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _components_PageContentWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41246);
/* harmony import */ var _components_NavBar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55270);
/* harmony import */ var _components_Head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26221);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80371);
/* harmony import */ var _components_domain_post_PostTags__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52463);







var PodcastsByTagPage = function(param) {
    var tag = param.tag, posts = param.posts;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_Head__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: "Podcasty | Street of Code",
                description: tag.raw,
                url: (0,_routes__WEBPACK_IMPORTED_MODULE_4__/* .prefixWithHost */ .O)(_routes__WEBPACK_IMPORTED_MODULE_4__/* .routes.clanky.tag */ ._.clanky.tag(tag.urlEconded))
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_NavBar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_PageContentWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_domain_post_PostTags__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    tag: tag,
                    posts: posts,
                    podcastTags: true
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PodcastsByTagPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7138,5270,9774,2888,179], function() { return __webpack_exec__(88211); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);